import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { Link, Redirect } from 'react-router-dom'

import { t } from '../translation/index'
import ChangeCard from '../components/Auth/ChangeCard'
import { resetAuthError, authFail, authRefreshToken } from 'store/actions'

const ENV = process.env.NODE_ENV

const stripePublicKey =
  ENV === 'production'
    ? process.env.STRIPE_PUBLIC_KEY_PRODUCTION
    : ENV === 'dev-remote'
    ? process.env.STRIPE_PUBLIC_KEY_DEV_REMOTE
    : process.env.STRIPE_PUBLIC_KEY_DEVELOPMENT

const stripePromise = loadStripe(stripePublicKey)
class MyAccount extends Component {
  componentDidMount() {
    document.documentElement.classList.add('no_scale_mod')
    this.setState({ scaleClassIsSet: true })
  }

  render() {
    if (this.props.isDoctor && !this.props.subscribed) return <Redirect to="/" />

    return (
      <div>
        <Elements
          stripe={stripePromise}
          options={{
            fonts: [
              {
                family: 'Bariol',
                // TODO: Temporary solution, figure out why local import 'url(/fonts/Bariol-Regular.woff2)' 'url(./fonts/Bariol-Regular.woff2)' or 'url(fonts/Bariol-Regular.woff2)' does not work
                src: 'url(https://sound-care-storage-prod.s3.amazonaws.com/assets/Bariol-Regular.woff2)',
                weight: '400',
              },
            ],
          }}
        >
          <div className="modal_content modal_open">
            <div className="popup acc_mod save_files_mod">
              <div className="popup_in offset_mod">
                <h2 className="section_title v5_mod offset_mod">
                  {t('settings.VIEW_ACCOUNT')}
                </h2>
                <ChangeCard formButton={`${t('settings.CHANGE_CARD')}`} />
                {!this.props.updatePayment && (
                  <Link
                    to="/my-account"
                    className="close_btn right_pos_mod account_mod"
                  ></Link>
                )}
              </div>
            </div>
          </div>
        </Elements>
      </div>
    )
  }
}

const mapStateToProps = ({ auth: { error, attributes, isDoctor } }) => ({
  authError: error,
  userCreatedDate: new Date(attributes.userCreatedDate),
  attributes,
  freeDays: attributes.licenses.freeDays,
  isDoctor,
  subscribed: JSON.parse(attributes?.subscribed || false),
  updatePayment: attributes.updatePayment,
})
const willMapDispatchToProps = {
  authFail,
  resetAuthError,
  authRefreshToken,
}

export default connect(mapStateToProps, willMapDispatchToProps)(MyAccount)
